import { Component, Inject, OnInit } from '@angular/core';
import { RemarkService } from '../service/remark.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditRemarkComponent } from '../edit-remark/edit-remark.component';


@Component({
  selector: 'app-delete-remark',
  templateUrl: './delete-remark.component.html',
  styleUrls: ['./delete-remark.component.scss']
})
export class DeleteRemarkComponent implements OnInit {
  remarkId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditRemarkComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _remarkService: RemarkService) {
    this.remarkId = data.remarkId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._remarkService.deleteRemark(this.airportId, this.remarkId);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
